import { Routes } from '@angular/router';
import { processGuard } from './guards/process-guard';

export const routes: Routes = [

  {path: '', redirectTo: 'accessDenied', pathMatch: 'full' },

  {
    path: 'welcome', loadComponent: async () =>
      import('./Components/ScreeningComponents/screening/screening.component').then((c) => c.ScreeningComponent)
  },
  {
    path: 'accessDenied', loadComponent: async () =>
      import('./Components/AccessComponents/access-denied/access-denied.component').then((c) => c.AccessDeniedComponent)
  },
  {
    path: 'process',
    canActivate: [processGuard],
    loadComponent: async () =>
      import('./Components/ScreeningComponents/questions/questions.component').then((c) => c.QuestionsComponent),
  },
  {
    path: 'session/:id', loadComponent: async () =>
      import('./Components/AccessComponents/session/session.component').then((c) => c.SessionComponent),
  },
  {
    path: 'finish', loadComponent: async () =>
      import('./Components/AlertComponents/alert-dialog-after-test/alert-dialog-after-test.component').then((c) => c.AlertDialogAfterTestComponent),
  },
  {path: '**', redirectTo: 'accessDenied' },
];
